module.exports = __webpack_public_path__ + "static/media/fan-table.2e33a0a0.svg";